import { useState } from 'react';
import measureDisplayMode from '@Local/Measurement/data/measureDisplayMode';

export const useSwitchDisplayMode = (initialMode = measureDisplayMode.graph) => {
    const [displayMode, setDisplayMode] = useState(initialMode);

    const toggleDisplayMode = () => {
        setDisplayMode((prev) =>
            prev === measureDisplayMode.graph
                ? measureDisplayMode.text
                : measureDisplayMode.graph
        );
    };

    const isGraphMode = displayMode === measureDisplayMode.graph;
    const isTextMode = displayMode === measureDisplayMode.text;

    return {
        displayMode,
        setDisplayMode,
        toggleDisplayMode,
        isGraphMode,
        isTextMode
    };
};
